import { useState, useEffect } from 'react';

const navItems = [
  { label: '首页', href: '#hero' },
  { label: '热门排行', href: '#ranking' },
  { label: '最新资讯', href: '#cards' },
  { label: '漫漫视频', href: '#media' },
  { label: '读者好评', href: '#comments' },
  { label: '联系我们', href: '#contact' },
];

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const handleNavClick = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    setMenuOpen(false);
    const el = document.querySelector(href);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/70'
          : 'bg-transparent'
      }`}
    >
      <div className="max-w-[1280px] mx-auto px-4 md:px-6 flex items-center justify-between h-[72px]">
        <a
          href="#hero"
          onClick={(e) => handleNavClick(e, '#hero')}
          className="flex items-center gap-2 cursor-pointer no-underline"
        >
          <span className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg">
            <i className="ri-book-open-line text-lg text-background-50"></i>
          </span>
          <span className="text-xl md:text-2xl font-heading font-bold text-foreground-950">
            漫漫漫画
          </span>
        </a>

        <nav className="hidden md:flex items-center gap-1">
          {navItems.map((item) => (
            <a
              key={item.href}
              href={item.href}
              onClick={(e) => handleNavClick(e, item.href)}
              className="px-4 py-2 text-sm font-medium text-foreground-700 hover:text-primary-500 rounded-md hover:bg-background-100 transition-colors duration-200 cursor-pointer whitespace-nowrap no-underline"
            >
              {item.label}
            </a>
          ))}
        </nav>

        <div className="hidden md:flex items-center gap-3">
          <button className="px-4 py-2 text-sm font-medium text-foreground-700 hover:text-primary-500 transition-colors duration-200 cursor-pointer whitespace-nowrap bg-transparent border-0 rounded-md">
            <i className="ri-search-line mr-1"></i>搜索
          </button>
          <a
            href="#app"
            onClick={(e) => handleNavClick(e, '#app')}
            className="px-5 py-2 text-sm font-medium bg-primary-500 text-background-50 rounded-full hover:bg-primary-600 transition-colors duration-200 cursor-pointer whitespace-nowrap no-underline"
          >
            下载APP
          </a>
        </div>

        <button
          className="md:hidden w-10 h-10 flex items-center justify-center text-foreground-700 cursor-pointer bg-transparent border-0 rounded-md"
          onClick={() => setMenuOpen(!menuOpen)}
        >
          <i className={`text-xl ${menuOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
        </button>
      </div>

      {menuOpen && (
        <div className="md:hidden bg-background-50 border-b border-background-200/70 px-4 pb-4">
          <nav className="flex flex-col gap-1">
            {navItems.map((item) => (
              <a
                key={item.href}
                href={item.href}
                onClick={(e) => handleNavClick(e, item.href)}
                className="px-4 py-3 text-sm font-medium text-foreground-700 hover:text-primary-500 hover:bg-background-100 rounded-md transition-colors duration-200 cursor-pointer no-underline"
              >
                {item.label}
              </a>
            ))}
            <div className="border-t border-background-200/70 pt-3 mt-2 flex gap-3">
              <button className="flex-1 px-4 py-2 text-sm font-medium text-foreground-700 bg-background-100 rounded-full cursor-pointer whitespace-nowrap border-0">
                <i className="ri-search-line mr-1"></i>搜索
              </button>
              <a
                href="#app"
                onClick={(e) => handleNavClick(e, '#app')}
                className="flex-1 px-4 py-2 text-sm font-medium bg-primary-500 text-background-50 rounded-full hover:bg-primary-600 transition-colors duration-200 cursor-pointer whitespace-nowrap text-center no-underline"
              >
                下载APP
              </a>
            </div>
          </nav>
        </div>
      )}
    </header>
  );
}